import React, { useState } from "react";
import { View, Text, StyleSheet } from "react-native";

import Button from "@components/Button";
import { scale } from "@utils/scale";
import WheelPicker from "@components/WheelPicker";
import t from "@constants/localization";

const PATH = "screens/CLProfile/components/WheelPickerView";

const WheelPickerView = ({ data, value, index, onSubmit }) => {
  const [selectedValue, setValue] = useState();

  return (
    <View style={styles.container}>
      <View>
        <View style={styles.questionContainer}>
          <Text style={styles.questionText}>{data?.heading}</Text>
        </View>
        <View style={styles.dateTextContainer}>
          <Text style={styles.dateText}>{value}</Text>
        </View>
      </View>
      <View style={styles.dateContainer}>
        <View style={styles.datePickerContainer}>
          <WheelPicker
            data={data?.options}
            onChange={setValue}
            value={value}
            title="Year"
          />
        </View>
      </View>
      <Button
        btnText={t(`${PATH}/save`)}
        buttonFontType="bold"
        fontSize={scale(14)}
        buttonWidth="95%"
        onPress={() => onSubmit(index, { [data.name]: selectedValue })}
        height={scale(50)}
        borderRadius={8}
        textStyle={{ fontSize: scale(16), lineHeight: 22 }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#ffffff",
    borderRadius: 5,
    padding: 10,
    marginHorizontal: 10,
    overflow: "hidden",
    justifyContent: "space-between",
    flex: 1,
  },
  questionContainer: {
    flexDirection: "row",
    alignItems: "center",
    // justifyContent: "space-between",
    paddingRight: 10,
  },
  dateTextContainer: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderRadius: 8,
    padding: 10,
    marginVertical: 40,
    width: "95%",
  },
  dateText: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontWeight: "400",
    fontSize: 16,
  },
  questionText: {
    fontSize: 24,
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontWeight: "600",
  },
  dateContainer: {
    marginTop: 12,
    alignItems: "center",
    marginBottom: 10,
  },
  datePickerContainer: {
    alignItems: "center",
  },
});

export default WheelPickerView;
